import { gql } from '@apollo/client';

export const CREATE_SCHEDULE_CONFIGURATION_MUTATION = gql`
  mutation CreateScheduleConfiguration(
    $checklistId: uuid!
    $recurrenceType: String!
    $repeatEvery: Int!
    $dueInDays: Int!
    $endDate: timestamptz
    $scheduleAssignId: uuid!
    $createdBy: uuid!
    $checklistVersionId: uuid!
    $name: String!
    $repeatOnDays: [Int!]
    $nextRunAt: timestamptz
    $timeZone: String!
    $startAt: timestamptz!
    $repeatOnMonthDates: [Int!]
    $repeatOnWeekNumber: Int
    $repeatOnWeekDay: Int
  ) {
    insert_schedule_configuration_one(
      object: {
        checklist_id: $checklistId
        recurrence_type: $recurrenceType
        repeat_every: $repeatEvery
        due_in_days: $dueInDays
        end_date: $endDate
        schedule_assignments_id: $scheduleAssignId
        created_by: $createdBy
        checklist_version_id: $checklistVersionId
        name: $name
        repeat_on_days: $repeatOnDays
        next_run_at: $nextRunAt
        time_zone: $timeZone
        start_at: $startAt
        repeat_on_month_dates: $repeatOnMonthDates
        repeat_on_week_number: $repeatOnWeekNumber
        repeat_on_week_day: $repeatOnWeekDay
      }
    ) {
      id
      created_at
      end_date
      start_at
      time_zone
    }
  }
`;

export const CREATE_SCHEDULE_WORKFLOW_CONFIGURATION_MUTATION = gql`
  mutation CreateScheduleConfiguration(
    $checklistId: uuid!
    $recurrenceType: String!
    $repeatEvery: Int!
    $dueInDays: Int!
    $endDate: timestamptz
    $scheduleAssignId: uuid!
    $createdBy: uuid!
    $checklistVersionId: uuid!
    $name: String!
    $repeatOnDays: [Int!]
    $nextRunAt: timestamptz
    $timeZone: String!
    $startAt: timestamptz!
    $repeatOnMonthDates: [Int!]
    $repeatOnWeekNumber: Int
    $repeatOnWeekDay: Int
    $workflow_configuration_id: uuid!
  ) {
    insert_schedule_configuration_one(
      object: {
        checklist_id: $checklistId
        recurrence_type: $recurrenceType
        repeat_every: $repeatEvery
        due_in_days: $dueInDays
        end_date: $endDate
        schedule_assignments_id: $scheduleAssignId
        created_by: $createdBy
        checklist_version_id: $checklistVersionId
        name: $name
        repeat_on_days: $repeatOnDays
        next_run_at: $nextRunAt
        time_zone: $timeZone
        start_at: $startAt
        repeat_on_month_dates: $repeatOnMonthDates
        repeat_on_week_number: $repeatOnWeekNumber
        repeat_on_week_day: $repeatOnWeekDay
        workflow_configuration_id: $workflow_configuration_id
      }
    ) {
      id
      created_at
      end_date
      start_at
      time_zone
    }
  }
`;

export const CREATE_SCHEDULE_ASSIGNMENTS_MUTATION = gql`
  mutation CreateScheduleAssignments(
    $assignments: [schedule_assignments_insert_input!]!
  ) {
    insert_schedule_assignments(objects: $assignments) {
      affected_rows
      returning {
        id # ✅ Get the inserted ID
      }
    }
  }
`;

export const UPDATE_LAST_RUN_MUTATION = gql`
  mutation UpdateLastRun($scheduleId: uuid!, $lastRunAt: timestamptz!) {
    update_schedule_configuration_by_pk(
      pk_columns: { id: $scheduleId }
      _set: { last_run_at: $lastRunAt }
    ) {
      id
      last_run_at
    }
  }
`;

export const UPDATE_NEXT_RUN_MUTATION = gql`
  mutation UpdateNextRun($scheduleId: uuid!, $nextRunAt: timestamptz) {
    update_schedule_configuration_by_pk(
      pk_columns: { id: $scheduleId }
      _set: { next_run_at: $nextRunAt }
    ) {
      id
      next_run_at
    }
  }
`;

export const DELETE_LAST_RUN_MUTATION = gql`
  mutation DeleteLastRun($scheduleId: uuid!) {
    update_schedule_configuration_by_pk(
      pk_columns: { id: $scheduleId }
      _set: { is_deleted: true }
    ) {
      id
      is_deleted
    }
  }
`;

export const GET_ACTIVE_SCHEDULE_CONFIGURATIONS = gql`
  query GetActiveScheduleConfigurations {
    schedule_configurations(where: { is_active: { _eq: true } }) {
      id
      checklist_id
      recurrence_type
      repeat_every
      due_in_days
      end_date
      schedule_assignments_id
      created_by
      checklist_version_id
      name
      is_active
    }
  }
`;

export const GET_ACTIVE_SCHEDULES = gql`
  query GetActiveSchedules($projectId: uuid!) {
    schedule_configuration(
      where: {
        checklist: {
          project: { id: { _eq: $projectId }, is_deleted: { _is_null: true } }
          is_deleted: { _is_null: true }
        }
        is_deleted: { _eq: false }
        checklist_version_id: { _is_null: false }
        schedule_assignments: { user: { id: { _is_null: false } } }
        end_date: { _gte: "now()" }
        next_run_at: { _gte: "now()" }
      }
      order_by: { created_at: desc }
    ) {
      id
      name
      checklist_id
      checklist_version_id
      repeat_every
      repeat_on_days
      due_in_days
      recurrence_type
      is_active
      end_date
      start_at
      next_run_at
      created_at
      created_by
      repeat_on_week_day
      repeat_on_week_number
      repeat_on_month_dates
      createdByUser {
        id
        displayName
      }
      schedule_assignments {
        user {
          displayName
        }
      }
    }
  }
`;

export const GET_CHECKLIST_ACTIVE_SCHEDULES = gql`
  query GetActiveSchedules($projectId: uuid!, $checklistId: uuid!) {
    schedule_configuration(
      where: {
        checklist: {
          id: { _eq: $checklistId }
          project: { id: { _eq: $projectId }, is_deleted: { _is_null: true } }
          is_deleted: { _is_null: true }
        }
        is_deleted: { _eq: false }
        checklist_version_id: { _is_null: false }
        schedule_assignments: { user: { id: { _is_null: false } } }
        end_date: { _gte: "now()" }
        next_run_at: { _gte: "now()" }
      }
      order_by: { created_at: desc }
    ) {
      id
      name
      checklist_id
      checklist_version_id
      repeat_every
      repeat_on_days
      due_in_days
      recurrence_type
      is_active
      end_date
      start_at
      next_run_at
      created_at
      repeat_on_week_day
      repeat_on_week_number
      repeat_on_month_dates
      created_by
      createdByUser {
        id
        displayName
      }
      schedule_assignments {
        user {
          displayName
        }
      }
    }
  }
`;
